import { render, staticRenderFns } from "./share_of_search.vue?vue&type=template&id=2724019d&scoped=true"
import script from "./share_of_search.vue?vue&type=script&lang=js"
export * from "./share_of_search.vue?vue&type=script&lang=js"
import style0 from "./share_of_search.vue?vue&type=style&index=0&id=2724019d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724019d",
  null
  
)

export default component.exports